// @flow
import React, {Component} from "react";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import ProposalTop from "./ProposalTop/ProposalTop";
import ProposalBottom from "./ProposalBottom/ProposalBottom";
import {millisecondsPerFrame} from "../../../Utils/AppUtils";
import CurrentProposalSelectors from "../../../Store/Ducks/CurrentProposal/selectors";
import BackendOperations from "../../../Store/Middleware/Backend/operations";
import CurrentProposalOperations from "../../../Store/Ducks/CurrentProposal/operations";

const MAX_PROPOSAL_AGE_SECONDS = 25;
const MAX_PROPOSAL_AGE_MILLI = MAX_PROPOSAL_AGE_SECONDS * 1000;

type ConnectedProps = {
    doRideRequest: () => mixed,
    shouldRequestProposal: boolean,
    onProposalTimedout: () => mixed,
    isProposalValid: boolean,
    isProposalAccepted: boolean,
    pickup: Object,
    dropoff: Object,
    proposalTimestamp: number,
    onProposalAccept: () => mixed,
};

type State = {
    proposalAgeMilli: number,
}

class Proposal extends Component<ConnectedProps, State> {

    updateTimeSinceProposal: () => void;
    proposalTimerInterval: any; //IntervalID is not recognized for some reason

    constructor(props) {
        super(props);
        this.updateTimeSinceProposal = this.updateTimeSinceProposal.bind(this);
        this.proposalTimerInterval = undefined;
        this.state = {
            proposalAgeMilli: -1,
        };
    }

    updateTimeSinceProposal() {
        if (this.props.proposalTimestamp && !this.props.isProposalAccepted) {
            this.setState({proposalAgeMilli: Date.now() - this.props.proposalTimestamp});
        }
    }

    componentDidMount() {
        this.proposalTimerInterval = setInterval(this.updateTimeSinceProposal, millisecondsPerFrame);
        if (this.props.shouldRequestProposal) {
            this.props.doRideRequest();
        }
    }
    componentWillUnmount() {
        if (this.proposalTimerInterval) {
            clearInterval(this.proposalTimerInterval);
        }
    }

    shouldComponentUpdate(nextProps: ConnectedProps, nextState: State, nextContext: any) {
        if (!nextProps.isProposalValid) {
            return false;
        }
        if (nextState.proposalAgeMilli > MAX_PROPOSAL_AGE_MILLI) {
            nextProps.onProposalTimedout();
            return false;
        }
        return true;
    }

    render() {
        if (this.props.shouldRequestProposal) {
            return null;
        }
        return ([
            <ProposalTop key="proposal_top"
                         pickupAddress={this.props.pickup.address}
                         dropoffAddress={this.props.dropoff.address}
            />,
            <ProposalBottom key="proposal_bottom"
                            proposalProgress={(this.state.proposalAgeMilli / MAX_PROPOSAL_AGE_MILLI) * 100}
                            onProposalAccept={this.props.onProposalAccept}
            />
        ]);
    }
}

const mapStateToProps = (state, props) => {
    return {
        shouldRequestProposal: CurrentProposalSelectors.shouldRequestProposal(state),
        isProposalValid: CurrentProposalSelectors.isProposalValid(state),
        isProposalAccepted: CurrentProposalSelectors.isProposalAccepted(state),
        pickup: CurrentProposalSelectors.getProposalPickup(state),
        dropoff: CurrentProposalSelectors.getProposalDropoff(state),
        proposalTimestamp: CurrentProposalSelectors.getProposalTimestamp(state),
    };
};

const mapActionsToProps = (dispatch, props) => {
    return bindActionCreators(
        {
            doRideRequest: BackendOperations.doRideRequest,
            onProposalTimedout: CurrentProposalOperations.proposalTimedOut,
            onProposalAccept: BackendOperations.doAcceptRideProposal,
        },
        dispatch);
};
export default connect(mapStateToProps, mapActionsToProps)(Proposal);



// WEBPACK FOOTER //
// ./src/Components/Screen/Proposal/Proposal.js